import { Tooltip } from '@fluentui/react-components';
import { DocumentBulletList20Filled, DocumentBulletList20Regular, Form20Filled, Form20Regular } from '@fluentui/react-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormView } from '../../../contexts/useFormView';
import IconTabButton from '../../common/IconTabButton';
interface ActionBarButtonsProps {
    isReportActive: boolean;
    handleOpenPathToPortal: () => void;
    navigateToReport: () => void;
    hasForms: boolean;
    hasReport: boolean;
    isLoading: boolean;
}

const ActionBarButtons: React.FC<ActionBarButtonsProps> = ({
    isReportActive,
    handleOpenPathToPortal,
    navigateToReport,
    hasForms,
    hasReport,
    isLoading,
}) => {
    const { t } = useTranslation();
    const { getCurrentFormPageUrl } = useFormView();
    const url = getCurrentFormPageUrl();

    const noFormsTooltip = t('noFormsAreAvailable').toString();
    const noReportTooltip = t('noReportAvailable').toString();
    const disableFormsTab = !hasForms || isLoading;
    const disableReportTab = !hasReport;

    const formsTab = (
        <IconTabButton
            label={t('form').toString()}
            ariaLabel={!hasForms && !isLoading ? noFormsTooltip : t('form').toString()}
            icon={<Form20Regular />}
            activeIcon={<Form20Filled />}
            onButtonClick={(e: any) => {
                e.preventDefault();
                handleOpenPathToPortal();
            }}
            buttonKey='viewFormTabButton'
            url={url}
            isActive={!isReportActive}
            disabled={disableFormsTab}
            role='link'
        />
    );

    const reportTab = (
        <IconTabButton
            label={t('report').toString()}
            ariaLabel={disableReportTab ? noReportTooltip : t('report').toString()}
            icon={<DocumentBulletList20Regular />}
            activeIcon={<DocumentBulletList20Filled />}
            onButtonClick={() => {
                navigateToReport();
            }}
            buttonKey='reportTabButton'
            isActive={isReportActive}
            disabled={disableReportTab}
        />
    );

    return (
        <>
            {hasReport ? (
                reportTab
            ) : (
                <Tooltip content={noReportTooltip} relationship='description' appearance='inverted' withArrow positioning='above'>
                    <span>{reportTab}</span>
                </Tooltip>
            )}
            {hasForms ? (
                formsTab
            ) : (
                <Tooltip content={noFormsTooltip} relationship='description' appearance='inverted' withArrow positioning='above'>
                    <span>{formsTab}</span>
                </Tooltip>
            )}
        </>
    );
};

export default ActionBarButtons;
